// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...



});

import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {

	setTimeout(function () {

		if (wixWindow.formFactor === "Desktop") {
			wixLocation.to('/tattoos');
		}

	}, 2000);


    // if its mobile than no timeout (for the mobile welcome screen)

		if (wixWindow.formFactor === "Mobile") {
			wixLocation.to('/tattoos');
		}

	

});